export default {
  methods: {
    positioning(options = []) {
      return [...options].sort((a, b) => a.position - b.position)
    },
  },
}
